import React from 'react';
import PropTypes from 'prop-types';

function FaqItemWidget(props) {
    const [open, setOpen] = React.useState(false);

    if(!props?.title && !props?.items) return null;

    return (
        <div data-test-id="faq-wr" className={"widget widget-faqitem" + (props?.dark ? " bg-dark" : "")}>
            <div className='container-xl row mx-auto'>
                <div className='col-12 faq p-0'>
                    { props?.title ? 
                        <button
                            data-test-id="faq-btn"
                            type="button"
                            className={(props?.dark ? 'text-white ' : '') + 'faq-btn text text-semibold text-left w-100 pl-2 pl-md-4 pr-4 pr-md-5 py-2 py-md-3' + (open === false ? "" : " isActive")}
                            onClick={() => { open === false ? setOpen(true) : setOpen(false) }}
                        >
                            {props.title}
                        </button> : null
                    }
                    {
                        props?.items ?
                            <div className={"px-2 px-md-4 pb-2 pb-md-3 mt-0 mt-md-2" + (open === false ? " d-none" : " d-block")}>
                                {
                                    props.items.map((item, index) => {
                                        return (
                                            <div key={"faq_" + index}>
                                                { item?.title ? <p data-test-id={"faq-el-title-" + index} className="text-color-changeable text-small mb-0 mb-md-1">{item.title}</p> : null }
                                                { item?.text ? <p data-test-id={"faq-el-text-" + index} className={(props?.dark ? 'text-white ' : '') + "text-small mb-12 text-justify"}>{item.text}</p> : null }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            : null
                    }
                </div>
            </div>
        </div>
    )
}

FaqItemWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    positions: PropTypes.number,
    widget: PropTypes.string
}

export default FaqItemWidget;
